module.exports = __webpack_public_path__ + "img/2-warm.a49e8a51.webp";